exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment .loading{background-color:#ddd;position:relative;overflow:hidden}.payment .loading:before{content:\"\";display:block;position:absolute;left:-150px;top:0;height:100%;width:150px;background:linear-gradient(90deg,transparent 0,#eee 50%,transparent);animation:load 1.5s cubic-bezier(.4,0,.2,1) infinite}@keyframes load{0%{left:-150px}to{left:100%}}.payment .StripeElement{display:inline-block;padding:4px;border:1px solid #8f8f8f;border-radius:2px}.payment .StripeElement--empty.dirty,.payment .StripeElement--invalid{border-color:red}.payment .__PrivateStripeElement{width:100%}.payment p.help{margin-top:-1px!important}", ""]);

// exports
